<template>
  <div class="index">
    <div v-if="$route.path == '/index/provid'">
      <div class="content-top" v-if="state == 1">
        <div class="title">
          <span>我的套餐</span>
          <div class="buyrecord" @click="buyinfos">购买记录</div>
        </div>
        <div class="mypackagebox">
          <el-tooltip
            class="item"
            v-for="(item, index) in serviceList"
            effect="light"
            :key="index"
            :content="index != 0 ? '进入有效期内自动生效！' : ''"
            :disabled="index == 0"
            placement="top"
          >
            <div
              class="mypackage"
              :style="index != 0 ? 'filter: grayscale(100%);' : ''"
            >
              <div class="package-title">{{ item.serviceType }}</div>
              <div class="object">
                <div class="obj-name">总条数：</div>
                <div class="obj-key">{{ item.totalNum }}</div>
              </div>
              <div class="object">
                <div class="obj-name">
                  剩余条数
                  <el-tooltip
                    v-if="index == 0"
                    class="item"
                    effect="light"
                    content="当有效期内剩余条数不足时，请点击“升级套餐”购买更多条数"
                    placement="right"
                  >
                    <i class="el-icon-question"></i>
                  </el-tooltip>
                </div>
                <div class="obj-key">{{ item.surplusNum }}</div>
              </div>
              <div class="object">
                <div class="obj-name">
                  有效期
                  <el-tooltip
                    v-if="index == 0"
                    class="item"
                    effect="light"
                    content="当套餐即将到期或需一次购买多年时，请点击“继续购买”"
                    placement="right"
                  >
                    <i class="el-icon-question"></i>
                  </el-tooltip>
                </div>
                <div class="obj-key">
                  {{ item.beginTime.slice(0, 10)
                  }}<span style="margin: 0 6px">至</span
                  >{{ item.endTime.slice(0, 10) }}
                </div>
              </div>
              <div class="btns" v-if="index == 0">
                <div
                  class="upgrade"
                  v-if="item.serviceType !== '免费版'"
                  @click="upgrade(item)"
                >
                  升级套餐
                </div>
                <div class="purchase disable" v-else>升级</div>

                <div
                  class="purchase"
                  v-if="item.serviceType !== '免费版'"
                  @click="purchase(item)"
                >
                  继续购买
                </div>
                <div class="purchase disable" v-else>继续购买</div>
              </div>
            </div>
          </el-tooltip>
        </div>

        <div class="package">
          <div
            class="packageitem"
            v-for="(item, index) in mergepackage"
            :key="item.id"
            :style="`border-top: 12px solid ${
              index == 0
                ? '#d8d8d8'
                : index == 1
                ? '#3BC492'
                : index == 2
                ? '#2C88F8'
                : index == 3
                ? '#FCBD1A'
                : index == 4
                ? '#173475 '
                : '#000'
            }`"
          >
            <div class="item-title">
              <span>{{ item[0].packageName }} </span>
              <el-tooltip
                v-if="index == 0"
                class="item"
                effect="light"
                content="免费版不提供客服服务，如有使用问题，您可以查阅帮助文档。"
                placement="right"
              >
                <i class="el-icon-question" style="color: #ccc"></i>
              </el-tooltip>
            </div>
            <div
              v-if="item[0].packageName == '私有定制'"
              class="viptitle"
              style="color: #ea4f2c"
            >
              按需付费
            </div>
            <div class="item-price" v-else style="color: #ea4f2c">
              ￥<span style="color: #ea4f2c"
                >{{ item[0].price * item[0].preferentialPrice
                }}{{ item.length != 1 ? "+" : "" }}元</span
              >/{{ index == 0 ? "月" : "年" }}
            </div>
            <div class="item-person">
              {{
                index == mergepackage.length - 1
                  ? ""
                  : item[0].lowerLimit == 0
                  ? `适用于${item[0].upperLimit}人内`
                  : `适用于${item[0].lowerLimit}(含)-${
                      item[item.length - 1].upperLimit
                    }人`
              }}
            </div>
            <div
              class="item-buy freebtn"
              v-if="item[0].packageName == '免费版'"
            >
              购买
            </div>
            <div
              class="item-buy"
              v-if="
                item[0].packageName != '免费版' &&
                item[0].packageName != '私有定制'
              "
              @click="tobuy(item[0].packageName)"
            >
              购买
            </div>
            <div
              class="item-buys"
              v-if="item[0].packageName == '私有定制'"
              @click="showviptip"
            >
              咨询定制
            </div>
            <div
              class="viptip"
              v-if="
                item[0].packageName == '私有定制' && $store.state.vipshowTip
              "
            >
              <div class="viptip-left">
                <!-- <img v-if="vipchecked==1" src="@/assets/workvxkf.jpg" alt=""> -->
                <img v-if="vipchecked == 2" src="@/assets/kf.jpeg" alt="" />
                <img
                  v-if="vipchecked == 3"
                  src="@/assets/workvxkf.jpg"
                  alt=""
                />
              </div>
              <div class="viptip-right">
                <div
                  class="vipitem"
                  @click="changechecked(1)"
                  :id="vipchecked == 1 ? 'vipchecked' : ''"
                >
                  <img src="@/assets/qqicon.png" alt="" />
                  <span> 客服QQ </span>
                </div>
                <div
                  class="vipitem"
                  @click="changechecked(2)"
                  :id="vipchecked == 2 ? 'vipchecked' : ''"
                >
                  <img src="@/assets/vxicon.png" alt="" />
                  <span> 客服微信 </span>
                </div>
                <div
                  class="vipitem"
                  @click="changechecked(3)"
                  :id="vipchecked == 3 ? 'vipchecked' : ''"
                >
                  <img src="@/assets/wkvxicon.png" alt="" />
                  <span> 客服企业微信 </span>
                </div>
              </div>
            </div>
            <div class="item-line"></div>
            <div v-if="item[0].packageName != '私有定制'">
              <div class="item-infos">
                {{ item[0].num }}{{ item.length != 1 ? "+" : "" }}条/{{
                  item[0].packageName == "免费版" ? "月" : "年"
                }}
              </div>
              <div class="item-infos">
                {{ item[0].customTemplate }}个定制模板
              </div>
              <div class="item-infos">
                {{ item[0].defaultTemplate }}个默认模板
              </div>
              <div class="item-infos" v-if="item[0].smsNotify">
                可短信发送/查看<span v-if="item[0].packageName != '免费版'"
                  >(需单独购买)</span
                >
              </div>
              <div class="item-infos" v-if="item[0].emailNotify">
                可邮件发送/查看
              </div>
              <div class="item-infos" v-if="item[0].wechatNotify">
                可微信公众号发送/查看
              </div>
              <div class="item-infos" v-if="item[0].miniNotify">
                可微信小程序发送/查看
              </div>
              <div class="item-infos" v-if="item[0].qywxNotify">
                可企业微信发送/查看(需单独购买)
              </div>
              <div class="item-infos" v-if="item[0].notice">可发送公告</div>
              <div class="item-infos" v-if="item[0].recall">可撤回</div>
              <div class="item-infos" v-if="item[0].resend">可重发</div>
              <div class="item-infos" v-if="item[0].sign">
                可手写签名/一键签收
              </div>
            </div>
            <div class="vipinfos" v-else>
              <div class="item-infos">适用于：</div>
              <div class="item-infos">1600(含)人以上</div>
              <!-- <div class="item-infos">私有部署</div> -->
              <div class="item-infos" style="margin-top: 5vh">联系方式：</div>
              <div class="item-infos">18971608045</div>
              <div class="item-infos">微信：joyous-oa</div>
            </div>
          </div>
        </div>
      </div>
      <!-- <Purchaserecord v-if="state == 2" @itemclick="cpnclick"></Purchaserecord> -->
      <buypackage
        @dialogclose="changeDialog"
        :content="content"
        v-if="state == 3"
        @itemclick="cpnclick"
        :checkedpackage="checkedpackage"
        :upgradeinfo="upgradeinfo"
      ></buypackage>
      <uppackage
        @dialogclose="changeDialog"
        :content="content"
        v-if="state == 4"
        @itemclick="cpnclick"
        :checkedpackage="checkedpackage"
        :upgradeinfo="upgradeinfo"
      ></uppackage>
    </div>
    <router-view></router-view>

    <el-dialog
      :visible.sync="centerDialogVisible"
      width="480px"
      center
      top="25vh"
    >
      <div class="dialogtitle">
        <i
          class="el-icon-info"
          style="font-size: 19px; color: #3bc492; line-height: 19px"
        ></i>
        请联系客服
      </div>
      <div class="dialogbox">
        <div class="dialogleft">
          <div>电话：18971608045</div>
          <div>微信：joyous-oa</div>
          <div>（可直接微信扫描 右方二维码添加！）</div>
        </div>
        <div class="dialogright">
          <img src="@/assets/greenvx.png" alt="" />
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="centerDialogVisible = false"
          >关闭</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { packagesalary, customerServiceInfo } from "@/api/setUp.js";
import Purchaserecord from "@/components/Purchaserecord.vue";
import buypackage from "@/components/buypackage.vue";
import uppackage from "@/components/uppackage.vue";
import { getcatloglist } from "@/api/authController.js";
import { helpCenterPage, helpDetailById } from "@/api/setUp.js";
export default {
  name: "index",
  components: {
    Purchaserecord,
    buypackage,
    uppackage,
  },
  data() {
    return {
      packageList: [],
      centerDialogVisible: false,
      package: [],
      state: 1,
      checkedpackage: "",
      serviceList: [],
      upgradeinfo: [],
      mergepackage: [],
      showvip: false,
      vipchecked: 2,
      showinfos: true,
      catloginfo: {
        app: "SALARY",
        pageNumber: 0,
        size: 100,
        title: "",
      },
      pageinfo: {
        pageNumber: 0,
        size: 1000,
        catalogId: "",
        title: "购买须知",
      },
      content: "",
    };
  },
  methods: {
    changeDialog() {
      this.centerDialogVisible = true;
    },
    async getcatlog() {
      let { data } = await getcatloglist(this.catloginfo);
      let res = data.filter((item) => {
        return item.mask == "XIEYI";
      });
      this.pageinfo.catalogId = res[0].id;
      let { data: res1 } = await helpCenterPage(this.pageinfo);
      console.log(res1);
      let { data: res2 } = await helpDetailById({ id: res1[0].id });
      this.content = res2.content;
    },
    buyinfos() {
      this.$router.push("/index/provid/purchaserecord");
      this.$router.go(1);
    },
    changechecked(val) {
      if (val == 1) {
        window.open(
          "http://wpa.qq.com/msgrd?v=3&uin=3179561760&site=qq&menu=yes"
        );
      } else {
        this.vipchecked = val;
      }
    },
    showviptip() {
      this.$store.state.vipshowTip = !this.$store.state.vipshowTip;
    },
    cpnclick(val) {
      this.state = val;
    },
    tobuy(val) {
      console.log(val, "c1c11c1c1");
      this.state = 3;
      this.checkedpackage = val;
    },
    upgrade(val) {
      // 判断是不是私有定制

      if (
        val.packageId == this.packageList[this.packageList.length - 2].id ||
        !val.packageId
      ) {
        this.centerDialogVisible = true;
        return 0;
      }
      this.upgradeinfo = val;
      this.state = 4;
    },
    purchase(val) {
      console.log(val, "cccccc");
      if (
        val.packageId == this.packageList[this.packageList.length - 1].id ||
        !val.packageId
      ) {
        this.centerDialogVisible = true;
        return 0;
      }
      this.state = 3;
      this.checkedpackage = val.serviceType;
    },

    async getpackagelist() {
      let { data } = await packagesalary({ app: "salary" });
      this.packageList = data;
      // 获取所有套餐名称
      let packagename = [];
      data.forEach((item) => {
        packagename.push(item.packageName);
      });

      packagename = Array.from(new Set(packagename)); //套餐名称去重

      // 根据套餐名称将相同名称的套餐合并
      let mergepackage = [];
      packagename.forEach((item1) => {
        let packageitem = [];
        data.forEach((item) => {
          if (item.packageName == item1) {
            packageitem.push(item);
          }
        });
        mergepackage.push(packageitem);
      });
      this.mergepackage = mergepackage;
      console.log(this.mergepackage, "c1111c");
    },

    async getServiceList() {
      const { data } = await customerServiceInfo();
      console.log(data);
      data.forEach((item) => {
        item.isLoading = false;
      });
      this.serviceList = data;
    },
  },
  mounted() {
    this.getpackagelist();
    this.getServiceList();
    this.getcatlog();
  },
};
</script>

<style lang="less" scoped>
.content-top {
  background: #fff;
  margin: 10px 10px 0 10px;
  height: calc(100vh - 81px);
  overflow: auto;
  border-radius: 8px;
  padding: 2vh 14px;
  .title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    span {
      font-size: 20px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #2c2d3a;
      line-height: 28px;
    }
    .buyrecord {
      width: 120px;
      height: 40px;
      box-shadow: 0px 6px 58px 0px rgba(196, 203, 214, 0.1);
      border-radius: 20px;
      border: 1px solid #00c88e;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #3bc492;
      text-align: center;
      line-height: 38px;
      cursor: pointer;
    }
  }
  .mypackagebox {
    display: flex;
    align-items: center;
    justify-content: left;
    flex-wrap: wrap;
    .mypackage {
      min-width: 24%;
      min-height: 172px;
      background: #ffffff;
      border-radius: 8px;
      border: 1px solid #3bc492;
      padding: 15px 10px 0 10px;
      margin-top: 10px;
      margin-right: 10px;
      .package-title {
        font-size: 16px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #3bc492;
        line-height: 22px;
        margin-bottom: 8px;
      }
      .object {
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.7);
        line-height: 24px;
      }
      .btns {
        display: flex;
        align-items: center;
        justify-content: right;
        margin-top: 10px;
        .upgrade {
          width: 88px;
          height: 28px;
          background: #3bc492;
          border-radius: 14px;
          font-size: 13px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #ffffff;
          line-height: 27px;
          text-align: center;
          cursor: pointer;
        }
        .purchase {
          width: 88px;
          height: 28px;
          background: #ffffff;
          border-radius: 14px;
          border: 1px solid #3bc492;
          font-size: 13px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #3bc492;
          line-height: 27px;
          text-align: center;
          margin-left: 10px;
          cursor: pointer;
        }
      }
    }
  }
  .package {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .packageitem {
      width: 19%;
      min-height: 483px;
      background: #ffffff;
      box-shadow: 0px 0px 8px 0px rgba(196, 196, 196, 0.3);
      border-radius: 8px;
      margin-top: 18px;
      // border-top: 12px solid #d8d8d8;
      text-align: center;
      position: relative;
      padding-bottom: 20px;
      .viptitle {
        font-size: 24px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #2c2d3a;
        line-height: 29px;
      }
      .item-title {
        font-size: 20px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #2c2d3a;
        line-height: 20px;
        margin: 27px 0 10px 0;
      }
      .item-price {
        margin: 10px 0 5px 0;
        line-height: 29px;
        font-size: 14px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #838f99;
        line-height: 29px;
        span {
          font-size: 24px;
          font-family: SFProDisplay-Bold, SFProDisplay;
          font-weight: bold;
          color: #2c2d3a;
          margin: 0 5px;
        }
      }
      .item-person {
        height: 17px;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #838f99;
        line-height: 17px;
        margin: 0px 0 10px 0;
      }
      .item-buy {
        width: 120px;
        height: 36px;
        background: #3bc492;
        border-radius: 4px;
        font-size: 16px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #ffffff;
        line-height: 36px;
        text-align: center;
        margin: 0px auto;
        cursor: pointer;
      }
      .item-buys {
        width: 120px;
        height: 36px;
        background: #3bc492;
        border-radius: 4px;
        font-size: 16px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #ffffff;
        line-height: 36px;
        text-align: center;
        margin: 18px auto 10px;
        cursor: pointer;
      }
      .freebtn {
        background: #ccc;
        cursor: not-allowed;
      }
      .item-line {
        width: 188px;
        border-bottom: 1px solid #e0eaf1;
        margin: 0 auto;
        margin-top: 10px;
        margin-bottom: 9px;
      }
      .item-infos {
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 500;
        color: #2c2d3a;
        line-height: 23px;
      }
    }
  }
}
.content-bottom {
  width: 96%;
  height: 60vh;
  background: #fff;
  margin: 0 auto;
  margin-top: 8px;
  border-radius: 8px;
  padding: 16px 14px 0 14px;
}
.disable {
  cursor: not-allowed !important;
}
.viptip {
  width: 323px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: absolute;
  left: -155px;
  top: 160px;
  .viptip-left {
    width: 180px;
    height: 180px;
    background: #ffffff;
    box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.15);
    img {
      width: 90%;
    }
  }
  .viptip-right {
    width: 143px;
    height: 180px;
    background: #ffffff;
    box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.15);
    display: flex;
    align-content: center;
    justify-content: center;
    flex-direction: column;
    #vipchecked {
      background: rgba(59, 196, 146, 0.1);
    }
    .vipitem {
      width: 143px;
      height: 39px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(0, 0, 0, 0.7);
      line-height: 39px;
      text-align: left;
      display: flex;
      align-items: center;
      justify-content: left;
      cursor: pointer;
      img {
        width: 24px;
        height: 24px;
        margin: 0 11px 0 9px;
      }
    }
  }
}
// .buyrecord {
//   width: 120px;
//   height: 40px;
//   box-shadow: 0px 6px 58px 0px rgba(196, 203, 214, 0.1);
//   border-radius: 20px;
//   border: 1px solid #00c88e;
//   font-size: 16px;
//   font-family: PingFangSC-Regular, PingFang SC;
//   font-weight: 400;
//   color: #ffffff;
//   line-height: 24px;
//   text-align: center;
//   line-height: 40px;
// }
.dialogtitle {
  font-size: 18px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #303133;
  line-height: 19px;
  margin-top: -30px;
}
.dialogbox {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 12px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 450;
  color: #2c2d3a;
  line-height: 22px;
  padding: 0 25px;
  .dialogleft {
  }
  .dialogright {
    img {
      width: 96px;
    }
  }
}

/deep/ .el-dialog .el-dialog__body {
  padding-bottom: 0;
}
</style>
